





















































import { Component, Vue } from "vue-property-decorator";

@Component
export default class EnvironmentPlan extends Vue {
  menu = [
    {
      title: "Tabella Obiettivi/Iniziative",
      subtitle: "",
      to: "/object-initiative-maps",
      type: "",
    },
    {
      title: "Iniziative Validate e Progetti",
      subtitle: "",
      to: "/iniziative-validations",
      type: "",
    },
  ];

  onSurveyTypeClick(to: string, type = "") {
    if (type !== "link") {
      this.$router.push(to).catch(error => console.log(error));
    } else {
      window.open(to, "_blank");
    }
  }
}
